<form class="example-form">
  <mat-form-field
    appearance="outline"
    [floatLabel]="floatLabel ? 'always' : 'auto'"
    [ngClass]="{ search: icon }"
  >
    @if(icon){
    <mat-icon class="absolute -left-[7%]">search</mat-icon>
    }
    <mat-label>{{ label }}</mat-label>
    <input
      #inputAutocomplete
      type="text"
      matInput
      [formControl]="myControl"
      [matAutocomplete]="auto"
      class="absolute inset-0 z-10 text-invisible"
      style="width: 80%"
      (focus)="isDescription = true"
      (blur)="isDescription = false"
    />
    <div
      class="absolute top-1/2 -translate-y-1/2 pointer-events-none z-0 truncate caret-black"
      [ngClass]="{
        'w-[90%]': !loading && myControl.value.length >= 3,
        'w-full': loading,
        'left-[10px]': icon,
        'left-0': !icon
      }"
      [innerHTML]="formattedSelectedOption"
    ></div>
    @if(myControl.value.length < minValue && isDescription){
    <mat-hint class="text-primary-400"
      >Ingresar al menos {{ minValue - 1 }} letras</mat-hint
    >
    }
    <mat-error class="text-3xs-medium -ml-3 w-[115%]">{{
      errorMessage
    }}</mat-error>
    @if(loading){
    <span
      class="material-symbols-outlined loader text-primary-300 absolute -right-[2%]"
    >
      progress_activity
    </span>
    } @if(!loading && myControl.value.length >= 3 ){
    <div
      class="flex flex-row justify-center items-center rounded-full bg-gray-700 cursor-pointer mt-[4.5px] w-[13px] h-[13.5px] -right-[1%] absolute"
      (click)="clear()"
    >
      <span class="material-symbols-outlined text-white close"> close </span>
    </div>
    }
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFn"
      (optionSelected)="onOptionSelected()"
    >
      @for (option of options; track option) {
      <mat-option [value]="option.name" [disabled]="!option.id">
        <span
          [innerHTML]="highlightMatch(option.name, myControl.value ?? '')"
        ></span>
      </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>
